const Referrals = ({ player }) => {
  return (
    <div>
      <h3>User Referrals</h3>
      <ul>
        {/* {player.referrals.map((ref) => (
            <li key={ref.id}>
              {ref.referredUserName} - {ref.date}
            </li>
          ))} */}
      </ul>
    </div>
  );
};

export default Referrals;
